<template>

  <div class="vflex">

    <div class="vflex-row-0 vflex-header p-3">
      <div class="page-title">
        <div class="title">
          <h4>{{ $t('Career site') }}</h4>
        </div>
        <div class="btn-row">
          <div class="form-inline">
            <input-keyword
              @input="setKeywords"
              :placeholder="$t('Search')"
              class="mr-2" />
            <button
              type="button"
              class="btn btn-primary"
              @click="showCreateModal()">
              + {{ $t('New site') }}
              </button>
          </div>
        </div>
      </div>
    </div>

    <div class="vflex-row-1">

      <Paginaty
        :total="paginate.total"
        :pages="paginate.pages"
        :page="paginate.page"
        :creating="creating"
        :loading="loading"
        @changePage="loadData">

        <template slot="content">
          <table class="table">
            <thead>
              <tr>
                <th-sort field="name" :value="sort" @input="setSort">{{ $t('Name') }}</th-sort>
                <th-sort field="slug" :value="sort" @input="setSort">{{ $t('Slug') }}</th-sort>
                <th>{{ $t('Jobs') }}</th>
                <th-sort field="status" :value="sort" @input="setSort">{{ $t('Status') }}</th-sort>
                <th></th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item, index) in careersites"
                :key="index">
                <td class="text-truncate">
                  <a
                    v-if="item.status !== 'processing'"
                    href="javascript:void(0)"
                    @click="showEditModal(item)">{{ item.name }}</a>
                  <span v-else>{{ item.name }}</span>
                  <small
                    v-if="item.is_legacy"
                    class="d-block text-muted text-wrap">
                    {{ $t('This site is in legacy mode. A new editor experience is available: to use it, create a new career site.') }}
                  </small>
                </td>
                <td class="text-truncate">{{ item.slug }}</td>
                <td class="text-nowrap">{{ item.total_jobs }}</td>
                <td class="text-nowrap">
                  <span
                    v-if="isBlocked(item) || !statusOptions[item.status]"
                    class="badge"
                    :class="statusOptions[item.status] ? statusOptions[item.status].style : 'badge-light'">
                    <span
                      v-if="item.status === 'processing'"
                      class="spinner-border mr-1"
                      role="status"
                      style="width: 0.75rem; height: 0.75rem;"></span>
                    {{ statusOptions[item.status] ? statusOptions[item.status].label : item.status }}
                  </span>
                  <div
                    v-else
                    :class="{'box-loading': statusLoading === item._id}">
                    <div class="dropdown">
                      <button
                        type="button"
                        class="btn dropdown-toggle"
                        :class="statusOptions[item.status].button"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                        :disabled="statusLoading === item._id">
                        {{ statusOptions[item.status].label }}
                      </button>
                      <div class="dropdown-menu">
                        <button
                          type="button"
                          class="dropdown-item"
                          @click="setStatus(item, statusOptions[item.status].next)">
                          {{ statusOptions[item.status].action }}
                        </button>
                      </div>
                    </div>
                  </div>
                </td>
                <td class="text-nowrap">
                  <a
                    v-if="!isBlocked(item) && item.careersite_url"
                    :href="item.careersite_url"
                    class="btn btn-outline-secondary"
                    target="_blank"><i class="fas fa-globe" /> {{ $t('View site') }}</a>
                </td>
                <td class="text-nowrap">
                  <template v-if="!isBlocked(item)">
                    <router-link
                      class="btn btn-outline-secondary"
                      v-if="item.is_legacy"
                      to="/config/careerpage"><i class="fas fa-history" /> {{ $t('Legacy editor') }}</router-link>
                    <a
                      v-else
                      class="btn btn-outline-secondary"
                      :href="item.careersitebuilder_url"
                      target="_blank"><i class="fas fa-external-link-alt" /> {{ $t('Editor') }}</a>
                  </template>
                </td>
              </tr>
            </tbody>
          </table>
        </template>

        <template slot="noresults">
          {{ $t('There are no items') }}
        </template>

      </Paginaty>

      <careersite-form
        v-if="modal_select"
        :initCareersite="modal_select"
        @hideModal="hideModal ()"
        @deleted="loadData(); hideModal()"
        @saved="loadData(paginate.page); hideModal()"
        ></careersite-form>

    </div>

  </div>

</template>

<script>
import InputKeyword from '@/components/Fields/InputKeyword'
import CareersiteForm from './CareersiteForm'
import ThSort from '@/components/Parts/ThSort'
import Paginaty from '@/components/Paginaty/Paginaty'

export default {
  name: 'Careersite',
  components: {
    CareersiteForm,
    InputKeyword,
    ThSort,
    Paginaty
  },
  data () {
    return {
      creating: true,
      loading: true,
      modal_select: false,
      filters: {},
      sort: 'name',
      statusLoading: null,
      refreshTimer: null,
      statusOptions: {
        active: {
          label: this.$t('Active'),
          button: 'btn-success',
          next: 'inactive',
          action: this.$t('Desativar')
        },
        inactive: {
          label: this.$t('Inactive'),
          button: 'btn-secondary',
          next: 'active',
          action: this.$t('Ativar')
        },
        processing: {
          label: this.$t('Processing'),
          style: 'badge-warning'
        },
        error: {
          label: this.$t('Error'),
          style: 'badge-danger'
        }
      }
    }
  },
  computed: {
    careersites () {
      return this.$store.getters.getCareersites
    },
    paginate () {
      return this.$store.getters.getCareersitesPaginate
    }
  },
  created () {
    this.loadData()
  },
  beforeDestroy () {
    clearTimeout(this.refreshTimer)
  },
  methods: {
    /*
    loadData
    silent: refresh em background (nao mostra loading)
    */
    loadData (page, silent) {
      clearTimeout(this.refreshTimer)
      if (!silent) this.loading = true

      const params = {
        ...this.filters,
        page: page,
        sort: this.sort,
        limit: this.$default.limit
      }

      this.$store
      .dispatch('selectCareersites', params)
      .then((result) => {
        if (result.docs.length === 0 && result.page > 1) return this.loadData(1)
        this.loading = this.creating = false

        // se existe item processando, atualiza a cada 5 segundos
        const hasProcessing = result.docs.some(doc => doc.status === 'processing')
        if (hasProcessing) {
          this.refreshTimer = setTimeout(() => this.loadData(result.page, true), 5000)
        }
      })
    },
    /*
    filters
    */
    setKeywords (keywords) {
      this.filters = keywords ? {name: '~' + keywords} : {}
      this.loadData(1)
    },
    setSort (sort) {
      this.sort = sort
      this.loadData(1)
    },
    /*
    status
    bloqueado: processing ou error (sem acoes de editor/ver site, status nao clicavel)
    */
    isBlocked (item) {
      return item.status === 'processing' || item.status === 'error'
    },
    setStatus (item, status) {
      if (this.isBlocked(item) || item.status === status) return

      this.statusLoading = item._id

      this.$store
      .dispatch('updateCareersite', {
        _id: item._id,
        status: status
      })
      .then(() => {
        this.statusLoading = null
      })
      .catch(() => {
        this.statusLoading = null
      })
    },
    /*
    modal
    */
    showCreateModal () {
      this.modal_select = {}
    },
    showEditModal (item) {
      this.modal_select = item
    },
    hideModal () {
      this.modal_select = false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Careersite/Careersite.vue